<div class="div-arriere-plan-action" (click)="onDismiss(false)"></div>
<div class="div-global-action" style="text-align: center;" (click)="$event.stopPropagation()">
  <div id="center-square">
    <h1 class="text-lg dark-blue no-margin">Ajouter un électeur</h1>

    <div class="flex content-center gap-10">
      <!-- <button (click)="onDismiss(true)">Oui, je supprime</button>
      <button (click)="onDismiss(false)">Non, j'annule</button> -->

      <div class="pt-20 pb-20">
        <div class="flex gap-10">
          <div>
            <p class="dark-blue no-margin text-left">Prénom <span class="red">*</span></p>
            <input type="text" name="firstName" id="firstName" class="text-md dark-blue pap-input w-full" [(ngModel)]="firstName">
          </div>
          <div>
            <p class="dark-blue no-margin text-left">Nom <span class="red">*</span></p>
            <input type="text" name="lastName" id="lastName" class="text-md dark-blue pap-input w-full" [(ngModel)]="lastName">
          </div>
        </div>

        <p class="dark-blue no-margin text-left mt-5">Collège <span class="red">*</span></p>
        <input type="text" name="college" id="college" class="text-md dark-blue pap-input w-full" [(ngModel)]="college">
        <p class="dark-blue no-margin text-left mt-5">Email <span class="red">*</span></p>
        <input type="text" name="email" id="email" class="text-md dark-blue pap-input w-full" [(ngModel)]="email">
        <p class="dark-blue no-margin text-left mt-5">Numéro de téléphone</p>
        <input type="text" name="phoneNumber" id="phoneNumber" class="text-md dark-blue pap-input w-full" [(ngModel)]="phone">
        <p class="dark-blue no-margin text-left mt-5">Réponse à la question défi</p>
        <input type="text" name="challengeQuestion" id="challengeQuestion" class="text-md dark-blue pap-input w-full" [(ngModel)]="challenge">
      </div>


    </div>
    <div class="flex gap-10 content-center">
      <v8te-active-button [buttonText]="'Annuler'" [primaryColor]="'#ffffff'" [secondaryColor]="'#FFECEC'"
        [textPrimaryColor]="'#2B2D67'" [textSecondaryColor]="'#EF4444'" [border]="'solid 1px #D9D9D9'"
        (click)="onDismiss(false)" [height]="50" [minWidth]="120" [width]="140"
        [bold]="'true'"></v8te-active-button>

      <v8te-active-button [buttonText]="'Ajouter'" [primaryColor]="'#32A24C'" [secondaryColor]="'#DEFEE6'"
        [textPrimaryColor]="'#ffffff'" [textSecondaryColor]="'#32A24C'" [border]="'none'" (click)="isFormValid && onDismiss(true)"
        [height]="'50'" [minWidth]="'120'" [width]="'140'" [bold]="'true'"
        [active]="isFormValid"></v8te-active-button>

    </div>
  </div>
</div>